import * as React from 'react';
import { Card, CardItem, Left, Text, Body, Right, View } from 'native-base';
import Modal from '../../components/modal';

const parseMoney = value => parseFloat(isNaN(value) ? 0 : value).toFixed(2);

export default function TaxPopup({ calc, visible, closeModal }) {
	return (
		<Modal
			animationIn="slideInDown"
			animationOut="slideOutDown"
			entry="top"
			backdropColor="#295670"
			backdropPressToClose
			backButtonClose
			coverScreen
			style={{ width: 'auto', height: 'auto', maxHeight: '90%', margin: 'auto' }}
			swipeThreshold={100}
			isOpen={visible}
			onClosed={closeModal}
			swipeDirection="down">
			<Card>
				<CardItem header>
					<Text>Current Year Proportional Tax Estimate</Text>
				</CardItem>
				{!!calc &&
					calc.map((row, i) => (
						<View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', marginVertical: 4 }}>
							<Text style={{ fontSize: 13, fontWeight: row.summary ? '600' : '300', marginHorizontal: 10 }}>{row.text}</Text>

							<Text style={{ fontSize: 12, marginRight: 10 }}>{row.colone}</Text>

							<Text note>{row.coltwo}</Text>
							<Text note>{row.colthree ? ' x ' + row.colthree : ''}</Text>

							<Text style={{ textAlign: 'right', fontWeight: row.summary ? '600' : '300', marginHorizontal: 10, fontSize: 14 }}>{row.val ? '£' + row.val.toFixed(2) : '-'}</Text>
						</View>
					))}
			</Card>
		</Modal>
	);
}
